<div class="container-fluid h-100">
  <h1 class="font-34 font-trueno-bold">Liste des partenaires</h1>
  <div class="d-flex flex-row flex-wrap mt-4 gap-16" *ngIf="partnerList">

    <div class="box-shadow text-center py-3 pointer w-25 border br-16 transition025" *ngFor="let partner of partnerList" [routerLink]="'/admin/settings/housing-partner/'+ partner.id">
      {{partner.name}}
      <div class="minitext_2 mediumGray" *ngIf="partner['updated_at']">Dernière MAJ :
        <br>
        {{partner['updated_at'] | date:'shortDate':'':'FR'}}
        à {{ partner['updated_at'] | date:'shortTime':'':'FR'}}
      </div>
    </div>

  </div>
  <!-------------------------------------------  loader ----------------------------------------->
  <div class="flex-grow-1 d-flex align-items-center justify-content-center mb-5 h-100" *ngIf="isloading">
    <div class="spinner-border text-primary"></div>
  </div>



</div>
